<template>
    <div id="UploadAuthImage">
      <p class="mb-5">
        {{$t("Please upload the requested documents in this section, note that all submissions must be based on the description provided, otherwise your authentication will be denied. Before preparing the image, click on 'View Sample Image' and 'Text of the letter of commitment' and view.")}}
        <br>
        - {{$t('The time it takes to upload your images varies according to the size of the images and may take some time, please wait until the upload is complete.')}}
        <br>
        - {{$t('If the image quality is poor, it may not be approved and you may re-upload.')}}
      </p>

      <vs-alert color="warning" :title="$t('pending')" active="true" v-if="status=='pending'">
        {{$t('Your information is under review and please wait!')}}
      </vs-alert>
      <vs-alert color="danger" :title="$t('reject')" active="true" v-else-if="status=='reject'">
        {{dataUser.authImg['reason_'+islocale]}}
      </vs-alert>
      <vs-alert color="success" :title="$t('confirm')" active="true" v-else-if="status=='confirm'" icon-pack="feather" icon="icon-check">
        {{$t('The information in this section has been successfully verified.')}}
      </vs-alert>

      <div class="vx-col md:w-2/5 w-full my-5 mx-auto lg:flex">
        <vs-button class="mr-1 lg:w-1/2 active" type="line" icon-pack="feather" icon="icon-align-center" @click="popupAuthText=true">{{$t('Text of commitment')}}</vs-button>
        <vs-button class="lg:w-1/2" type="line" icon-pack="feather" icon="icon-image" @click="popupAuthImage=true">{{$t('View Sample Image')}}</vs-button>
      </div>

      <div class="vx-col md:w-2/5 w-full mt-8 mx-auto">
        <p class="mb-1">{{$t('Please upload the authentication photo according to the sample:')}}</p>
        <div :class="$vs.rtl ? 'rtl' : 'ltr'" dir="ltr">
          <file-pond
            :class="status=='pending'?'warning' : status=='confirm'?'success' : ''"
            name="test"
            ref="pond"
            :disabled="status=='pending'|| status=='confirm'  ? true : false"
            :captureMethod="null"
            :label-idle="$t('Click to upload the file or drag and drop the file')"
            accepted-file-types="image/jpeg, image/png"
            v-bind:server="myServer"
            :files="status=='pending'||status=='confirm' ? myFiles : null"
            :processfile="null"
          />
        </div>

        <transition name="slide">
          <div class="w-full flex px-3" v-if="uploadPercentage > 0">
            <p class="mr-3 text-center">20%</p>
            <vs-progress class="mt-1" :height="12" :percent="uploadPercentage" color="success"></vs-progress>
          </div>
        </transition>

        <vs-button class="ml-auto mt-2 w-full" id="button-submit-auth-img" :disabled="btnDisable ||status=='pending'||status=='confirm' ? true : false" @click.prevent="formSubmit">
          {{$t('Submit Information')}}
        </vs-button>
      </div>


      <vs-popup :title="$t('The text of the letter of commitment')" :active.sync="popupAuthText">
        <p class="text-justify">
          روی کاغذ متن زیر را بنویسید و در زمان ارسال مدارک در کنار مدارک خود، مطابق نمونه از آن استفاده کنید:
          <br>
          ضمن مطالعه و تایید قوانین فراچنج، مدارک اینجانب جهت تایید هویت در این سایت ارسال می گردد. همچنین متعهد می شوم مدارک و حساب کاربری یا بانکی خود را در اختیار شخص دیگری قرار ندهم.
          <br>
          نام و نام خانواگی:
          <br>
          امضا:
          <br>
          تاریخ:
        </p>
      </vs-popup>

      <vs-popup :title="$t('Sample photo authentication')" class="popup-img" :active.sync="popupAuthImage">
        <img class="responsive" src="@/assets/images/SelfieImg.jpg">
      </vs-popup>


    </div>


</template>
<i18n locale="fa">
{
  "The time it takes to upload your images varies according to the size of the images and may take some time, please wait until the upload is complete.":
  "مدت زمان آپلود تصاویر شما به نسبت حجم تصاویر متغییر است و ممکن است مدتی زمان ببرد، لطفا شکیبا باشید."

  ,"If the image quality is poor, it may not be approved and you may re-upload.":
  "اگر کیفیت تصویر نامناسب باشد ممکن است تایید نشود و مجدد آپلود نمایید."

  ,"Please upload the requested documents in this section, note that all submissions must be based on the description provided, otherwise your authentication will be denied. Before preparing the image, click on 'View Sample Image' and 'Text of the letter of commitment' and view.":
  "لطفا مدارک خواسته شده را در این بخش بارگذاری کنید، دقت داشته باشید که تمام موارد ارسالی بايد بر اساس توضیحات ارائه شده باشد، درغیر این صورت احراز هویت شما رد می‌شود. قبل از تهيه تصویر بر روی قسمت 'مشاهده تصویر نمونه' و 'متن تعهد نامه' کليک کرده و مشاهده نماييد."

  ,"View Sample Image":"مشاهده تصویر نمونه"
  ,"Text of commitment":"مشاهده متن تعهد نامه"
  ,"Please upload the authentication photo according to the sample:":"لطفا عکس احراز هویت را مطابق نمونه آپلود کنید:"
  ,"The text of the letter of commitment":"متن تعهد نامه"
  ,"Sample photo authentication":"نمونه عکس احراز هویت"
  ,"Please insert the file!":"لطفا فایل را درج کنید!"
  ,"Your information is under review and please wait!":"اطلاعات شما در دست بررسی قرار دارد و لطفا منتظر بمانید!"
  ,"The information in this section has been successfully verified.":"اطلاعات این بخش با موفقیت تایید شده است."

}
</i18n>
<script>

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'
// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import axios from "../../../http/axios";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
)

export default {
  props: {
    dataUser: {
      required: true,
    }
  },
  data () {
    return {
      popupAuthText: false,
      popupAuthImage: false,
      myFiles: [
        {
          source:
            "authentication/auth-img/image.jpg",
          options: {
            type: "local"
          }
        }
      ],
      status: null,
      uploadPercentage:0,
      btnDisable: false,
      myServer: {
        process: null,
        load: (source, load) => {
          axios.get(source, {responseType: 'blob' })
            .then((response) => {
              const new_blob = new Blob( [ response.data ], { type: 'image/jpg' } );
              load(new_blob)
            })
        }
      },
    }
  },
  methods:{
    formSubmit(){
      if(!this.$refs.pond.getFiles()[0]){
        this.$swal(this.$t('Warning'), this.$t('Please insert the file!'),'warning')
        return;
      }
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#button-submit-auth-img',
        scale: 0.65
      })
      this.btnDisable = true;
      const bodyFormData = new FormData()
      bodyFormData.append('file', this.$refs.pond.getFiles()[0].file);
      const self = this
      axios.post('/authentication/auth-img', bodyFormData,{
        onUploadProgress: function( progressEvent ) {
          this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
        }.bind(this)
      })
        .then(function (response) {
          if (response.data.status == true) {
            self.$swal({
              icon: 'success',
              title: self.$t('Success'),
              text: response.data.msg
            }).then(() => {
              self.$emit('getData')
              self.status = 'pending'
            })

          } else {
            self.$vs.notify({title: self.$t('Error'), text: response.data.msg, iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'})
          }
          self.btnDisable = false
          self.uploadPercentage = 0
          self.$vs.loading.close('#button-submit-auth-img > .con-vs-loading')
        })
        .catch(function (error) {
          console.log(error)
          self.uploadPercentage = 0
          self.btnDisable = false
          self.$vs.loading.close('#button-submit-auth-img > .con-vs-loading')
        })
    }
  },
  created() {

    if(this.dataUser.authImg && this.dataUser.authImg.status){
      this.status = this.dataUser.authImg.status;
    }
  },
  components: {
    FilePond
  }
}
</script>

<style lang="scss">
  #UploadAuthImage{
    .rtl .filepond--wrapper div{
      direction: rtl;
      text-align: right;
    }
    .rtl .filepond--wrapper .filepond--file-info{
      margin: 0em;
    }

    .rtl .filepond--file .filepond--file-status{
      margin-right: auto;
      margin-left: 2.25em !important;
    }

    .filepond--file-info,.filepond--file-status{
      font-size: 18px !important;
    }
    .filepond--credits{
      display: none;
    }

    .filepond--file-action-button,.filepond--drop-label, .filepond--drop-label label{
      cursor: pointer;
    }

    /* the text color of the drop label*/
    .filepond--drop-label {
      color: #555;
      font-family: iranyekan,"Montserrat", Helvetica, Arial, sans-serif;
    }

    /* underline color for "Browse" button */
    .filepond--label-action {
      text-decoration-color: #aaa;
    }

    /* the background color of the filepond drop area */
    .filepond--panel-root {
      background-color: #eee;
    }

    /* the border radius of the drop area */
    .filepond--panel-root {
      border-radius: 0.5em;
    }

    /* the border radius of the file item */
    .filepond--item-panel {
      border-radius: 0.5em;
    }

    /* the background color of the file and file panel (used when dropping an image) */
    .filepond--item-panel {
      background-color: #555;
    }

    /* the background color of the drop circle */
    .filepond--drip-blob {
      background-color: #999;
    }

    /* the background color of the black action buttons */
    .filepond--file-action-button {
      background-color: rgba(0, 0, 0, 0.5);
    }

    /* the icon color of the black action buttons */
    .filepond--file-action-button {
      color: white;
    }

    /* the color of the focus ring */
    .filepond--file-action-button:hover,
    .filepond--file-action-button:focus {
      box-shadow: 0 0 0 0.125em rgba(255, 255, 255, 0.9);
    }

    /* the text color of the file status and info labels */
    .filepond--file {
      color: white;
    }

    /* error state color */
    [data-filepond-item-state*='error'] .filepond--item-panel,
    [data-filepond-item-state*='invalid'] .filepond--item-panel {
      //background-color: red;
    }

    [data-filepond-item-state='processing-complete'] .filepond--item-panel {
      background-color: green;
    }

    /* bordered drop area */
    .filepond--panel-root {
      background-color: transparent;
      border: 2px solid #2c3340;
    }

    .filepond--file-status-sub,.filepond--file-info-sub{
      opacity: 0.8 !important;
    }
    .success .filepond--panel-root{
      border-color: rgba(var(--vs-success), 1) !important;
    }
    .warning .filepond--panel-root{
      border-color: rgba(var(--vs-warning), 1) !important;
    }

  }
</style>
